import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './ContextMenu.css';

const ContextMenu = ({ isOpen, position, onRename, onDelete, onClose, items }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // If items prop exists, use it for dynamic rendering
  // Otherwise, use legacy onRename/onDelete props for backwards compatibility
  const renderMenuItems = () => {
    if (items && Array.isArray(items)) {
      return items.map((item, index) => (
        <div
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            item.onClick(e);
          }}
          className={`context-menu-item w-full px-3 py-2.5 text-sm text-left flex items-center gap-2 cursor-pointer rounded-lg
            ${item.danger ? 'text-red-500 dark:text-red-500' : 'text-gray-900 dark:text-white'}`}
          style={{ fontFamily: 'var(--chat-font-family)' }}
        >
          {item.icon}
          {item.label}
        </div>
      ));
    } else {
      // Legacy support
      return (
        <>
          <div
            onClick={(e) => {
              e.stopPropagation();
              onRename(e);
            }}
            className="context-menu-item w-full px-3 py-2.5 text-sm text-left text-gray-900 dark:text-white flex items-center gap-2 cursor-pointer rounded-lg"
            style={{ fontFamily: 'var(--chat-font-family)' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
            </svg>
            Rename
          </div>
          <div
            onClick={(e) => {
              e.stopPropagation();
              onDelete(e);
            }}
            className="context-menu-item w-full px-3 py-2.5 text-sm text-left text-red-500 dark:text-red-500 flex items-center gap-2 cursor-pointer rounded-lg"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4">
              <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
            </svg>
            Delete
          </div>
        </>
      );
    }
  };

  return createPortal(
    <div 
      className="fixed"
      style={{ 
        left: position.x - 10,
        top: position.y - 5,
        zIndex: 1000
      }}
      ref={menuRef}
    >
      <div 
        className="context-menu-dropdown w-40 m-2 rounded-xl shadow-lg py-1.5 px-1.5"
        onClick={(e) => e.stopPropagation()}
      >
        {renderMenuItems()}
      </div>
    </div>,
    document.body
  );
};

export default ContextMenu; 